const Home = () =>{
    return (
        <div className='homepage'>Login or Signup to Continue.</div>
    )
}

export default Home